//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseResponse implements IBaseResponse {
    title?: string | undefined;
    message?: string | undefined;
    redirectUrl?: string | undefined;

    constructor(data?: IBaseResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["Title"];
            this.message = _data["Message"];
            this.redirectUrl = _data["RedirectUrl"];
        }
    }

    static fromJS(data: any): BaseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BaseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Title"] = this.title;
        data["Message"] = this.message;
        data["RedirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IBaseResponse {
    title?: string | undefined;
    message?: string | undefined;
    redirectUrl?: string | undefined;
}

export class ConfirmEmailAddressRequest implements IConfirmEmailAddressRequest {
    hash?: string | undefined;
    verificationCode?: string | undefined;
    email?: string | undefined;

    constructor(data?: IConfirmEmailAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hash = _data["Hash"];
            this.verificationCode = _data["VerificationCode"];
            this.email = _data["Email"];
        }
    }

    static fromJS(data: any): ConfirmEmailAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Hash"] = this.hash;
        data["VerificationCode"] = this.verificationCode;
        data["Email"] = this.email;
        return data;
    }
}

export interface IConfirmEmailAddressRequest {
    hash?: string | undefined;
    verificationCode?: string | undefined;
    email?: string | undefined;
}

export class ResponseModel implements IResponseModel {
    access?: boolean;
    reason?: string | undefined;

    constructor(data?: IResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["Access"];
            this.reason = _data["Reason"];
        }
    }

    static fromJS(data: any): ResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Access"] = this.access;
        data["Reason"] = this.reason;
        return data;
    }
}

export interface IResponseModel {
    access?: boolean;
    reason?: string | undefined;
}

export class TrailModel extends ResponseModel implements ITrailModel {
    trailId?: number;
    id?: string;
    routeId?: string | undefined;
    gps?: boolean;
    gpsOnly?: boolean;
    name?: string | undefined;
    friendlyUrlName?: string | undefined;
    type?: string | undefined;
    maps?: TrailMapInfo[] | undefined;
    mapsGps?: TrailMapInfo[] | undefined;
    mapsIntro?: TrailMapInfo[] | undefined;
    gpsData?: string[] | undefined;
    descriptionAvailable?: boolean;
    intro?: string | undefined;
    description?: string | undefined;
    distanceShort?: number;
    distance?: number;
    displayDistance?: string | undefined;
    bereikbaarPerTrein?: boolean;
    bereikbaarPerOv?: boolean;
    markering?: boolean;
    meerdaags?: boolean;
    excludeSingleTrail?: boolean;
    rondtocht?: boolean;
    lijntocht?: boolean;
    honden?: boolean | undefined;
    horecaStart?: boolean;
    horecaOnderweg?: boolean;
    nordicWalk?: boolean;
    eBike?: boolean;
    fietsVerhuur?: boolean;
    kanoVerhuur?: boolean;
    jutterVerhuur?: boolean;
    locatieNaam?: string | undefined;
    locatieAdres?: string | undefined;
    locatiePostcode?: string | undefined;
    locatiePlaats?: string | undefined;
    locatieProvincie?: string | undefined;
    locatieProvincieCode?: string | undefined;
    locatieInfo?: string | undefined;
    auteurId?: number;
    auteurGpsId?: number;
    coAuteurIds?: string | undefined;
    controleurIds?: string | undefined;
    controleurGpsId?: number;
    colofon?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    status?: string | undefined;
    reactions?: TrailReactionModel[] | undefined;
    lastModified?: Date | undefined;
    lastAudited?: Date | undefined;
    auditNow?: boolean;
    auditInfo?: AuditInfo | undefined;
    aanbieder?: TrailAanbieder | undefined;
    difficultyClassification?: DifficultyClassificationModel[] | undefined;
    begeleiderGewenst?: boolean;
    hulphonden?: boolean;
    bankjesOnderweg?: boolean;
    wildrooster?: boolean;
    hekkenOfSluisjes?: boolean;
    treinToegankelijkRolstoel?: boolean;
    ovToegankelijkRolstoel?: boolean;
    gehandicaptenparkeerplaats?: boolean;
    locationHoreca?: boolean;
    locationToegangkelijkRolstoel?: boolean;
    locationToiletToegangkelijkRolstoel?: boolean;
    onderwegToiletToegangkelijkRolstoel?: boolean;
    bandenpompAanwezig?: boolean;
    acculaderAanwezig?: boolean;
    guideline?: boolean;
    losloopgebied?: boolean;
    hellingshoek?: EnumHellingshoek;
    dwarshelling?: EnumDwarshelling;
    richels?: EnumRichels;
    wildroosterZelfstandigTePasseren?: boolean;
    sporenTussenruimteMax50?: boolean;
    hekkenOfSluisjesZelfstandigTePasseren?: boolean;
    wildroosterGrootsteAfstandSpijlen?: number;
    onderwegToegangkelijkRolstoel?: boolean;
    verhardwegdek?: boolean;
    halfverhardFijnEgaalwegdek?: boolean;
    halfverhardGrofHobbeligwegdek?: boolean;
    onverhardStevigeOndergrond?: boolean;
    onverhardZachteOndergrond?: boolean;
    markeringToelichting?: string | undefined;
    begeleiderGewenstToelichting?: string | undefined;
    bankjesOnderwegToelichting?: string | undefined;
    hellingshoekToelichting?: string | undefined;
    dwarshellingToelichting?: string | undefined;
    obstakelsToelichting?: string | undefined;
    wildroosterToelichting?: string | undefined;
    hekkenOfSluisjesToelichting?: string | undefined;
    ondergrondToelichting?: string | undefined;
    inkorting2?: number;
    bandenpompOnderweg?: boolean;
    acculaderOnderweg?: boolean;
    guidlineVanafOV?: boolean;
    isOop?: boolean;
    doorgangenOveralMinimaal90?: boolean;
    minimaleBreedteDoorgang?: number | undefined;
    toelichtingSporen?: string | undefined;
    sporen?: boolean | undefined;
    freeTrailConditions?: FreeTrailConditions | undefined;

    constructor(data?: ITrailModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trailId = _data["TrailId"];
            this.id = _data["Id"];
            this.routeId = _data["RouteId"];
            this.gps = _data["Gps"];
            this.gpsOnly = _data["GpsOnly"];
            this.name = _data["Name"];
            this.friendlyUrlName = _data["FriendlyUrlName"];
            this.type = _data["Type"];
            if (Array.isArray(_data["Maps"])) {
                this.maps = [] as any;
                for (let item of _data["Maps"])
                    this.maps!.push(TrailMapInfo.fromJS(item));
            }
            if (Array.isArray(_data["MapsGps"])) {
                this.mapsGps = [] as any;
                for (let item of _data["MapsGps"])
                    this.mapsGps!.push(TrailMapInfo.fromJS(item));
            }
            if (Array.isArray(_data["MapsIntro"])) {
                this.mapsIntro = [] as any;
                for (let item of _data["MapsIntro"])
                    this.mapsIntro!.push(TrailMapInfo.fromJS(item));
            }
            if (Array.isArray(_data["GpsData"])) {
                this.gpsData = [] as any;
                for (let item of _data["GpsData"])
                    this.gpsData!.push(item);
            }
            this.descriptionAvailable = _data["DescriptionAvailable"];
            this.intro = _data["Intro"];
            this.description = _data["Description"];
            this.distanceShort = _data["DistanceShort"];
            this.distance = _data["Distance"];
            this.displayDistance = _data["DisplayDistance"];
            this.bereikbaarPerTrein = _data["BereikbaarPerTrein"];
            this.bereikbaarPerOv = _data["BereikbaarPerOv"];
            this.markering = _data["Markering"];
            this.meerdaags = _data["Meerdaags"];
            this.excludeSingleTrail = _data["ExcludeSingleTrail"];
            this.rondtocht = _data["Rondtocht"];
            this.lijntocht = _data["Lijntocht"];
            this.honden = _data["Honden"];
            this.horecaStart = _data["HorecaStart"];
            this.horecaOnderweg = _data["HorecaOnderweg"];
            this.nordicWalk = _data["NordicWalk"];
            this.eBike = _data["EBike"];
            this.fietsVerhuur = _data["FietsVerhuur"];
            this.kanoVerhuur = _data["KanoVerhuur"];
            this.jutterVerhuur = _data["JutterVerhuur"];
            this.locatieNaam = _data["LocatieNaam"];
            this.locatieAdres = _data["LocatieAdres"];
            this.locatiePostcode = _data["LocatiePostcode"];
            this.locatiePlaats = _data["LocatiePlaats"];
            this.locatieProvincie = _data["LocatieProvincie"];
            this.locatieProvincieCode = _data["LocatieProvincieCode"];
            this.locatieInfo = _data["LocatieInfo"];
            this.auteurId = _data["AuteurId"];
            this.auteurGpsId = _data["AuteurGpsId"];
            this.coAuteurIds = _data["CoAuteurIds"];
            this.controleurIds = _data["ControleurIds"];
            this.controleurGpsId = _data["ControleurGpsId"];
            this.colofon = _data["Colofon"];
            this.lat = _data["Lat"];
            this.lng = _data["Lng"];
            this.status = _data["Status"];
            if (Array.isArray(_data["Reactions"])) {
                this.reactions = [] as any;
                for (let item of _data["Reactions"])
                    this.reactions!.push(TrailReactionModel.fromJS(item));
            }
            this.lastModified = _data["LastModified"] ? new Date(_data["LastModified"].toString()) : <any>undefined;
            this.lastAudited = _data["LastAudited"] ? new Date(_data["LastAudited"].toString()) : <any>undefined;
            this.auditNow = _data["AuditNow"];
            this.auditInfo = _data["AuditInfo"] ? AuditInfo.fromJS(_data["AuditInfo"]) : <any>undefined;
            this.aanbieder = _data["Aanbieder"] ? TrailAanbieder.fromJS(_data["Aanbieder"]) : <any>undefined;
            if (Array.isArray(_data["DifficultyClassification"])) {
                this.difficultyClassification = [] as any;
                for (let item of _data["DifficultyClassification"])
                    this.difficultyClassification!.push(DifficultyClassificationModel.fromJS(item));
            }
            this.begeleiderGewenst = _data["BegeleiderGewenst"];
            this.hulphonden = _data["Hulphonden"];
            this.bankjesOnderweg = _data["BankjesOnderweg"];
            this.wildrooster = _data["Wildrooster"];
            this.hekkenOfSluisjes = _data["HekkenOfSluisjes"];
            this.treinToegankelijkRolstoel = _data["TreinToegankelijkRolstoel"];
            this.ovToegankelijkRolstoel = _data["OvToegankelijkRolstoel"];
            this.gehandicaptenparkeerplaats = _data["Gehandicaptenparkeerplaats"];
            this.locationHoreca = _data["LocationHoreca"];
            this.locationToegangkelijkRolstoel = _data["LocationToegangkelijkRolstoel"];
            this.locationToiletToegangkelijkRolstoel = _data["LocationToiletToegangkelijkRolstoel"];
            this.onderwegToiletToegangkelijkRolstoel = _data["OnderwegToiletToegangkelijkRolstoel"];
            this.bandenpompAanwezig = _data["BandenpompAanwezig"];
            this.acculaderAanwezig = _data["AcculaderAanwezig"];
            this.guideline = _data["Guideline"];
            this.losloopgebied = _data["Losloopgebied"];
            this.hellingshoek = _data["Hellingshoek"];
            this.dwarshelling = _data["Dwarshelling"];
            this.richels = _data["Richels"];
            this.wildroosterZelfstandigTePasseren = _data["WildroosterZelfstandigTePasseren"];
            this.sporenTussenruimteMax50 = _data["SporenTussenruimteMax50"];
            this.hekkenOfSluisjesZelfstandigTePasseren = _data["HekkenOfSluisjesZelfstandigTePasseren"];
            this.wildroosterGrootsteAfstandSpijlen = _data["WildroosterGrootsteAfstandSpijlen"];
            this.onderwegToegangkelijkRolstoel = _data["OnderwegToegangkelijkRolstoel"];
            this.verhardwegdek = _data["Verhardwegdek"];
            this.halfverhardFijnEgaalwegdek = _data["HalfverhardFijnEgaalwegdek"];
            this.halfverhardGrofHobbeligwegdek = _data["HalfverhardGrofHobbeligwegdek"];
            this.onverhardStevigeOndergrond = _data["OnverhardStevigeOndergrond"];
            this.onverhardZachteOndergrond = _data["OnverhardZachteOndergrond"];
            this.markeringToelichting = _data["MarkeringToelichting"];
            this.begeleiderGewenstToelichting = _data["BegeleiderGewenstToelichting"];
            this.bankjesOnderwegToelichting = _data["BankjesOnderwegToelichting"];
            this.hellingshoekToelichting = _data["HellingshoekToelichting"];
            this.dwarshellingToelichting = _data["DwarshellingToelichting"];
            this.obstakelsToelichting = _data["ObstakelsToelichting"];
            this.wildroosterToelichting = _data["WildroosterToelichting"];
            this.hekkenOfSluisjesToelichting = _data["HekkenOfSluisjesToelichting"];
            this.ondergrondToelichting = _data["OndergrondToelichting"];
            this.inkorting2 = _data["Inkorting2"];
            this.bandenpompOnderweg = _data["BandenpompOnderweg"];
            this.acculaderOnderweg = _data["AcculaderOnderweg"];
            this.guidlineVanafOV = _data["GuidlineVanafOV"];
            this.isOop = _data["IsOop"];
            this.doorgangenOveralMinimaal90 = _data["DoorgangenOveralMinimaal90"];
            this.minimaleBreedteDoorgang = _data["MinimaleBreedteDoorgang"];
            this.toelichtingSporen = _data["ToelichtingSporen"];
            this.sporen = _data["Sporen"];
            this.freeTrailConditions = _data["FreeTrailConditions"] ? FreeTrailConditions.fromJS(_data["FreeTrailConditions"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TrailModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrailModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrailId"] = this.trailId;
        data["Id"] = this.id;
        data["RouteId"] = this.routeId;
        data["Gps"] = this.gps;
        data["GpsOnly"] = this.gpsOnly;
        data["Name"] = this.name;
        data["FriendlyUrlName"] = this.friendlyUrlName;
        data["Type"] = this.type;
        if (Array.isArray(this.maps)) {
            data["Maps"] = [];
            for (let item of this.maps)
                data["Maps"].push(item.toJSON());
        }
        if (Array.isArray(this.mapsGps)) {
            data["MapsGps"] = [];
            for (let item of this.mapsGps)
                data["MapsGps"].push(item.toJSON());
        }
        if (Array.isArray(this.mapsIntro)) {
            data["MapsIntro"] = [];
            for (let item of this.mapsIntro)
                data["MapsIntro"].push(item.toJSON());
        }
        if (Array.isArray(this.gpsData)) {
            data["GpsData"] = [];
            for (let item of this.gpsData)
                data["GpsData"].push(item);
        }
        data["DescriptionAvailable"] = this.descriptionAvailable;
        data["Intro"] = this.intro;
        data["Description"] = this.description;
        data["DistanceShort"] = this.distanceShort;
        data["Distance"] = this.distance;
        data["DisplayDistance"] = this.displayDistance;
        data["BereikbaarPerTrein"] = this.bereikbaarPerTrein;
        data["BereikbaarPerOv"] = this.bereikbaarPerOv;
        data["Markering"] = this.markering;
        data["Meerdaags"] = this.meerdaags;
        data["ExcludeSingleTrail"] = this.excludeSingleTrail;
        data["Rondtocht"] = this.rondtocht;
        data["Lijntocht"] = this.lijntocht;
        data["Honden"] = this.honden;
        data["HorecaStart"] = this.horecaStart;
        data["HorecaOnderweg"] = this.horecaOnderweg;
        data["NordicWalk"] = this.nordicWalk;
        data["EBike"] = this.eBike;
        data["FietsVerhuur"] = this.fietsVerhuur;
        data["KanoVerhuur"] = this.kanoVerhuur;
        data["JutterVerhuur"] = this.jutterVerhuur;
        data["LocatieNaam"] = this.locatieNaam;
        data["LocatieAdres"] = this.locatieAdres;
        data["LocatiePostcode"] = this.locatiePostcode;
        data["LocatiePlaats"] = this.locatiePlaats;
        data["LocatieProvincie"] = this.locatieProvincie;
        data["LocatieProvincieCode"] = this.locatieProvincieCode;
        data["LocatieInfo"] = this.locatieInfo;
        data["AuteurId"] = this.auteurId;
        data["AuteurGpsId"] = this.auteurGpsId;
        data["CoAuteurIds"] = this.coAuteurIds;
        data["ControleurIds"] = this.controleurIds;
        data["ControleurGpsId"] = this.controleurGpsId;
        data["Colofon"] = this.colofon;
        data["Lat"] = this.lat;
        data["Lng"] = this.lng;
        data["Status"] = this.status;
        if (Array.isArray(this.reactions)) {
            data["Reactions"] = [];
            for (let item of this.reactions)
                data["Reactions"].push(item.toJSON());
        }
        data["LastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["LastAudited"] = this.lastAudited ? this.lastAudited.toISOString() : <any>undefined;
        data["AuditNow"] = this.auditNow;
        data["AuditInfo"] = this.auditInfo ? this.auditInfo.toJSON() : <any>undefined;
        data["Aanbieder"] = this.aanbieder ? this.aanbieder.toJSON() : <any>undefined;
        if (Array.isArray(this.difficultyClassification)) {
            data["DifficultyClassification"] = [];
            for (let item of this.difficultyClassification)
                data["DifficultyClassification"].push(item.toJSON());
        }
        data["BegeleiderGewenst"] = this.begeleiderGewenst;
        data["Hulphonden"] = this.hulphonden;
        data["BankjesOnderweg"] = this.bankjesOnderweg;
        data["Wildrooster"] = this.wildrooster;
        data["HekkenOfSluisjes"] = this.hekkenOfSluisjes;
        data["TreinToegankelijkRolstoel"] = this.treinToegankelijkRolstoel;
        data["OvToegankelijkRolstoel"] = this.ovToegankelijkRolstoel;
        data["Gehandicaptenparkeerplaats"] = this.gehandicaptenparkeerplaats;
        data["LocationHoreca"] = this.locationHoreca;
        data["LocationToegangkelijkRolstoel"] = this.locationToegangkelijkRolstoel;
        data["LocationToiletToegangkelijkRolstoel"] = this.locationToiletToegangkelijkRolstoel;
        data["OnderwegToiletToegangkelijkRolstoel"] = this.onderwegToiletToegangkelijkRolstoel;
        data["BandenpompAanwezig"] = this.bandenpompAanwezig;
        data["AcculaderAanwezig"] = this.acculaderAanwezig;
        data["Guideline"] = this.guideline;
        data["Losloopgebied"] = this.losloopgebied;
        data["Hellingshoek"] = this.hellingshoek;
        data["Dwarshelling"] = this.dwarshelling;
        data["Richels"] = this.richels;
        data["WildroosterZelfstandigTePasseren"] = this.wildroosterZelfstandigTePasseren;
        data["SporenTussenruimteMax50"] = this.sporenTussenruimteMax50;
        data["HekkenOfSluisjesZelfstandigTePasseren"] = this.hekkenOfSluisjesZelfstandigTePasseren;
        data["WildroosterGrootsteAfstandSpijlen"] = this.wildroosterGrootsteAfstandSpijlen;
        data["OnderwegToegangkelijkRolstoel"] = this.onderwegToegangkelijkRolstoel;
        data["Verhardwegdek"] = this.verhardwegdek;
        data["HalfverhardFijnEgaalwegdek"] = this.halfverhardFijnEgaalwegdek;
        data["HalfverhardGrofHobbeligwegdek"] = this.halfverhardGrofHobbeligwegdek;
        data["OnverhardStevigeOndergrond"] = this.onverhardStevigeOndergrond;
        data["OnverhardZachteOndergrond"] = this.onverhardZachteOndergrond;
        data["MarkeringToelichting"] = this.markeringToelichting;
        data["BegeleiderGewenstToelichting"] = this.begeleiderGewenstToelichting;
        data["BankjesOnderwegToelichting"] = this.bankjesOnderwegToelichting;
        data["HellingshoekToelichting"] = this.hellingshoekToelichting;
        data["DwarshellingToelichting"] = this.dwarshellingToelichting;
        data["ObstakelsToelichting"] = this.obstakelsToelichting;
        data["WildroosterToelichting"] = this.wildroosterToelichting;
        data["HekkenOfSluisjesToelichting"] = this.hekkenOfSluisjesToelichting;
        data["OndergrondToelichting"] = this.ondergrondToelichting;
        data["Inkorting2"] = this.inkorting2;
        data["BandenpompOnderweg"] = this.bandenpompOnderweg;
        data["AcculaderOnderweg"] = this.acculaderOnderweg;
        data["GuidlineVanafOV"] = this.guidlineVanafOV;
        data["IsOop"] = this.isOop;
        data["DoorgangenOveralMinimaal90"] = this.doorgangenOveralMinimaal90;
        data["MinimaleBreedteDoorgang"] = this.minimaleBreedteDoorgang;
        data["ToelichtingSporen"] = this.toelichtingSporen;
        data["Sporen"] = this.sporen;
        data["FreeTrailConditions"] = this.freeTrailConditions ? this.freeTrailConditions.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ITrailModel extends IResponseModel {
    trailId?: number;
    id?: string;
    routeId?: string | undefined;
    gps?: boolean;
    gpsOnly?: boolean;
    name?: string | undefined;
    friendlyUrlName?: string | undefined;
    type?: string | undefined;
    maps?: TrailMapInfo[] | undefined;
    mapsGps?: TrailMapInfo[] | undefined;
    mapsIntro?: TrailMapInfo[] | undefined;
    gpsData?: string[] | undefined;
    descriptionAvailable?: boolean;
    intro?: string | undefined;
    description?: string | undefined;
    distanceShort?: number;
    distance?: number;
    displayDistance?: string | undefined;
    bereikbaarPerTrein?: boolean;
    bereikbaarPerOv?: boolean;
    markering?: boolean;
    meerdaags?: boolean;
    excludeSingleTrail?: boolean;
    rondtocht?: boolean;
    lijntocht?: boolean;
    honden?: boolean | undefined;
    horecaStart?: boolean;
    horecaOnderweg?: boolean;
    nordicWalk?: boolean;
    eBike?: boolean;
    fietsVerhuur?: boolean;
    kanoVerhuur?: boolean;
    jutterVerhuur?: boolean;
    locatieNaam?: string | undefined;
    locatieAdres?: string | undefined;
    locatiePostcode?: string | undefined;
    locatiePlaats?: string | undefined;
    locatieProvincie?: string | undefined;
    locatieProvincieCode?: string | undefined;
    locatieInfo?: string | undefined;
    auteurId?: number;
    auteurGpsId?: number;
    coAuteurIds?: string | undefined;
    controleurIds?: string | undefined;
    controleurGpsId?: number;
    colofon?: string | undefined;
    lat?: number | undefined;
    lng?: number | undefined;
    status?: string | undefined;
    reactions?: TrailReactionModel[] | undefined;
    lastModified?: Date | undefined;
    lastAudited?: Date | undefined;
    auditNow?: boolean;
    auditInfo?: AuditInfo | undefined;
    aanbieder?: TrailAanbieder | undefined;
    difficultyClassification?: DifficultyClassificationModel[] | undefined;
    begeleiderGewenst?: boolean;
    hulphonden?: boolean;
    bankjesOnderweg?: boolean;
    wildrooster?: boolean;
    hekkenOfSluisjes?: boolean;
    treinToegankelijkRolstoel?: boolean;
    ovToegankelijkRolstoel?: boolean;
    gehandicaptenparkeerplaats?: boolean;
    locationHoreca?: boolean;
    locationToegangkelijkRolstoel?: boolean;
    locationToiletToegangkelijkRolstoel?: boolean;
    onderwegToiletToegangkelijkRolstoel?: boolean;
    bandenpompAanwezig?: boolean;
    acculaderAanwezig?: boolean;
    guideline?: boolean;
    losloopgebied?: boolean;
    hellingshoek?: EnumHellingshoek;
    dwarshelling?: EnumDwarshelling;
    richels?: EnumRichels;
    wildroosterZelfstandigTePasseren?: boolean;
    sporenTussenruimteMax50?: boolean;
    hekkenOfSluisjesZelfstandigTePasseren?: boolean;
    wildroosterGrootsteAfstandSpijlen?: number;
    onderwegToegangkelijkRolstoel?: boolean;
    verhardwegdek?: boolean;
    halfverhardFijnEgaalwegdek?: boolean;
    halfverhardGrofHobbeligwegdek?: boolean;
    onverhardStevigeOndergrond?: boolean;
    onverhardZachteOndergrond?: boolean;
    markeringToelichting?: string | undefined;
    begeleiderGewenstToelichting?: string | undefined;
    bankjesOnderwegToelichting?: string | undefined;
    hellingshoekToelichting?: string | undefined;
    dwarshellingToelichting?: string | undefined;
    obstakelsToelichting?: string | undefined;
    wildroosterToelichting?: string | undefined;
    hekkenOfSluisjesToelichting?: string | undefined;
    ondergrondToelichting?: string | undefined;
    inkorting2?: number;
    bandenpompOnderweg?: boolean;
    acculaderOnderweg?: boolean;
    guidlineVanafOV?: boolean;
    isOop?: boolean;
    doorgangenOveralMinimaal90?: boolean;
    minimaleBreedteDoorgang?: number | undefined;
    toelichtingSporen?: string | undefined;
    sporen?: boolean | undefined;
    freeTrailConditions?: FreeTrailConditions | undefined;
}

export class TrailMapInfo extends ResponseModel implements ITrailMapInfo {
    trailId?: string;
    id?: string;
    type?: number;
    name?: string | undefined;
    description?: string | undefined;

    constructor(data?: ITrailMapInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trailId = _data["TrailId"];
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.name = _data["Name"];
            this.description = _data["Description"];
        }
    }

    static override fromJS(data: any): TrailMapInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TrailMapInfo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TrailId"] = this.trailId;
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Name"] = this.name;
        data["Description"] = this.description;
        super.toJSON(data);
        return data;
    }
}

export interface ITrailMapInfo extends IResponseModel {
    trailId?: string;
    id?: string;
    type?: number;
    name?: string | undefined;
    description?: string | undefined;
}

export class TrailReactionModel implements ITrailReactionModel {
    imageUrl?: string | undefined;
    trailId?: string;
    name?: string | undefined;
    stars?: number;
    description?: string | undefined;
    imageCode?: string | undefined;
    date?: string | undefined;
    id?: number;

    constructor(data?: ITrailReactionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["ImageUrl"];
            this.trailId = _data["TrailId"];
            this.name = _data["Name"];
            this.stars = _data["Stars"];
            this.description = _data["Description"];
            this.imageCode = _data["ImageCode"];
            this.date = _data["Date"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): TrailReactionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrailReactionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ImageUrl"] = this.imageUrl;
        data["TrailId"] = this.trailId;
        data["Name"] = this.name;
        data["Stars"] = this.stars;
        data["Description"] = this.description;
        data["ImageCode"] = this.imageCode;
        data["Date"] = this.date;
        data["Id"] = this.id;
        return data;
    }
}

export interface ITrailReactionModel {
    imageUrl?: string | undefined;
    trailId?: string;
    name?: string | undefined;
    stars?: number;
    description?: string | undefined;
    imageCode?: string | undefined;
    date?: string | undefined;
    id?: number;
}

export class AuditInfo implements IAuditInfo {
    needsAudit?: boolean;
    lastAudit?: Date | undefined;

    constructor(data?: IAuditInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.needsAudit = _data["NeedsAudit"];
            this.lastAudit = _data["LastAudit"] ? new Date(_data["LastAudit"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AuditInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NeedsAudit"] = this.needsAudit;
        data["LastAudit"] = this.lastAudit ? this.lastAudit.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAuditInfo {
    needsAudit?: boolean;
    lastAudit?: Date | undefined;
}

export class TrailAanbieder implements ITrailAanbieder {
    name?: string | undefined;
    afdeling?: string | undefined;
    contactpersoon?: string | undefined;
    adres?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    emailaddress?: string | undefined;
    telefoonnummer?: string | undefined;
    website?: string | undefined;

    constructor(data?: ITrailAanbieder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.afdeling = _data["Afdeling"];
            this.contactpersoon = _data["Contactpersoon"];
            this.adres = _data["Adres"];
            this.postcode = _data["Postcode"];
            this.plaats = _data["Plaats"];
            this.emailaddress = _data["Emailaddress"];
            this.telefoonnummer = _data["Telefoonnummer"];
            this.website = _data["Website"];
        }
    }

    static fromJS(data: any): TrailAanbieder {
        data = typeof data === 'object' ? data : {};
        let result = new TrailAanbieder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Afdeling"] = this.afdeling;
        data["Contactpersoon"] = this.contactpersoon;
        data["Adres"] = this.adres;
        data["Postcode"] = this.postcode;
        data["Plaats"] = this.plaats;
        data["Emailaddress"] = this.emailaddress;
        data["Telefoonnummer"] = this.telefoonnummer;
        data["Website"] = this.website;
        return data;
    }
}

export interface ITrailAanbieder {
    name?: string | undefined;
    afdeling?: string | undefined;
    contactpersoon?: string | undefined;
    adres?: string | undefined;
    postcode?: string | undefined;
    plaats?: string | undefined;
    emailaddress?: string | undefined;
    telefoonnummer?: string | undefined;
    website?: string | undefined;
}

export class DifficultyClassificationModel implements IDifficultyClassificationModel {
    vehicleType?: EnumVoertuigType;
    withHandler?: boolean;
    difficulty?: EnumTrailDifficulty;

    constructor(data?: IDifficultyClassificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleType = _data["VehicleType"];
            this.withHandler = _data["WithHandler"];
            this.difficulty = _data["Difficulty"];
        }
    }

    static fromJS(data: any): DifficultyClassificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DifficultyClassificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["VehicleType"] = this.vehicleType;
        data["WithHandler"] = this.withHandler;
        data["Difficulty"] = this.difficulty;
        return data;
    }
}

export interface IDifficultyClassificationModel {
    vehicleType?: EnumVoertuigType;
    withHandler?: boolean;
    difficulty?: EnumTrailDifficulty;
}

export type EnumVoertuigType = 1000 | 1001 | 1002 | 1003 | 1004 | 1005 | 1006 | 1007;

export type EnumTrailDifficulty = 0 | 1 | 2 | 3 | 4;

export type EnumHellingshoek = 0 | 1 | 2 | 3 | 4 | 5;

export type EnumDwarshelling = 0 | 1 | 2 | 3;

export type EnumRichels = 0 | 1 | 2 | 3 | 4;

export class FreeTrailConditions implements IFreeTrailConditions {
    isFreeTrail?: boolean;
    isEmailRequired?: boolean;
    isEmailValidationRequired?: boolean;

    constructor(data?: IFreeTrailConditions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFreeTrail = _data["IsFreeTrail"];
            this.isEmailRequired = _data["IsEmailRequired"];
            this.isEmailValidationRequired = _data["IsEmailValidationRequired"];
        }
    }

    static fromJS(data: any): FreeTrailConditions {
        data = typeof data === 'object' ? data : {};
        let result = new FreeTrailConditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsFreeTrail"] = this.isFreeTrail;
        data["IsEmailRequired"] = this.isEmailRequired;
        data["IsEmailValidationRequired"] = this.isEmailValidationRequired;
        return data;
    }
}

export interface IFreeTrailConditions {
    isFreeTrail?: boolean;
    isEmailRequired?: boolean;
    isEmailValidationRequired?: boolean;
}